<template>
  <v-dialog v-model="show" persistent max-width="600">
    <v-card rounded="xl" prepend-icon="mdi-alert" :title="message.title">
      <v-card-text v-html="htmlText"></v-card-text>
      <v-divider class="my-3"></v-divider>
      <v-card-actions>
        <v-btn v-if="!alertMode" color="success" @click="handleResponse(true)">Yes</v-btn>
        <v-btn v-if="!alertMode" color="secondary" @click="handleResponse(false)">No</v-btn>
         <v-btn v-if="alertMode" color="primary" @click="handleResponse(true)">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DOMPurify from 'dompurify';

export default {
  name: "ConfirmationAlert",
  data() {
    return {
      show: false,
      message: { title: '', text: '' },
      htmlText: '',
      _resolver: null,
      alertMode: false, // display only alert with ok button
    };
  },
  methods: {
    open(msg) {
      this.alertMode = msg?.alertMode || false;
      this.message = msg || { title: '', text: '' };
      const raw = (this.message.text || '').toString();
      const withBreaks = raw.replace(/\r\n|\r|\n/g, '<br/>');
      this.htmlText = DOMPurify.sanitize(withBreaks);
      this.show = true;
      return new Promise((resolve) => {
        this._resolver = resolve;
      });
    },
    handleResponse(result) {
      this.show = false;
      if (this._resolver) {
        this._resolver(result);
        this._resolver = null;
      }
    },
  },
};
</script>